import React from 'react'
import SummaryReportMenuItem from './SummaryReportMenuItem'
import { I18n } from 'react-redux-i18n'
import AppBar from '../../components/AppBar'

export default () => {
  const label = I18n.t('summaryReportScene')
  return (
    <div>
      <AppBar header="Summary Report" hasBtnGroup />
      <div className="pt-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-8">
            <SummaryReportMenuItem
              to="/summary-report/booking-summary"
              title={label.bookingSummary.title}
              icon="calendar"
            />
            <SummaryReportMenuItem
              to="/summary-report/customer-summary"
              title={label.customerSummary.title}
              icon="users"
            />
            <SummaryReportMenuItem
              to="/summary-report/work-summary"
              title={label.workSummary.title}
              icon="briefcase"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
